import { useLayoutEffect, useRef, useState } from 'react';

import { Tooltip, TooltipProps } from '@/design-system';
import { cn } from '@/utils/tailwind';

interface TruncatedTextWithTooltipProps {
  text?: string;
  placement?: TooltipProps['side'];
  className?: string;
}

export const TruncatedTextWithTooltip = ({
  text,
  placement,
  className,
}: TruncatedTextWithTooltipProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = () => {
    if (textRef.current) {
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  };

  useLayoutEffect(() => {
    checkTruncation();

    const resizeObserver = new ResizeObserver(() => {
      checkTruncation();
    });

    if (textRef.current) {
      resizeObserver.observe(textRef.current);
    }

    return () => {
      resizeObserver.disconnect();
    };
  }, [text]);

  return (
    <Tooltip
      title={isTruncated ? text : undefined}
      side={placement}
      tooltipClassName={className}
    >
      <span
        className={cn('truncate whitespace-nowrap', className)}
        ref={textRef}
      >
        {text}
      </span>
    </Tooltip>
  );
};
